import React, { Component } from "react";
import { connect } from "react-redux";
import { message, Row, Col, Select } from "antd";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import * as XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {
  ButtonItem,
  ModalItem,
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  RangePickerItem,
  SegmentedItem,
} from "../../../../Components/Items";
import reporteCargasCombustiblePdf from "../../../../Pdf/reporteCargasCombustiblePdf";
import {
  computarRendimientoPorCamion,
  resumenGlobal,
  resumenPorCamion,
  resumenPorChofer,
  detectarAnomalias,
} from "./cargasCombustible.utils";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const TIPOS = [
  { label: "Consumo por camión", value: "flota" },
  { label: "Detalle de un camión", value: "camion" },
  { label: "Detección de anomalías", value: "anomalias" },
];

class ModalReportesCargas extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    tipo: "flota",
  };

  cerrar() {
    if (this.formRef.current) this.formRef.current.resetFields();
    this.props.cerrar();
  }

  async obtenerDatos(values) {
    const { tipo } = this.state;
    let proyectoIds;
    if (tipo === "camion") {
      proyectoIds = [values.camionId];
    } else {
      proyectoIds = values.camiones && values.camiones.length ? values.camiones : undefined; // vacío = todos
    }

    const res = await axios.post(
      "rendimientos/reporteCargasCombustible",
      {
        empresaId: this.props.empresaId,
        proyectoIds,
        fechaInicio: values.periodo[0].toISOString(),
        fechaFin: values.periodo[1].toISOString(),
      },
      { headers: this.props.headersToken }
    );

    const cargas = (res.data && res.data.cargas) || [];
    const cargasComp = computarRendimientoPorCamion(cargas);
    return { cargasComp, empresa: res.data.empresa || null, vehiculos: res.data.vehiculos || [] };
  }

  async generar(formato) {
    let values;
    try {
      values = await this.formRef.current.validateFields();
    } catch {
      return; // errores de validación ya mostrados
    }
    const { tipo } = this.state;
    this.setState({ loading: true });
    try {
      const { cargasComp, empresa } = await this.obtenerDatos(values);
      if (cargasComp.length === 0) {
        this.setState({ loading: false });
        return message.info("No hay cargas en el período seleccionado");
      }

      const fechaInicio = values.periodo[0];
      const fechaFin = values.periodo[1];
      const sufijo = moment().format("YYYY-MM-DD");

      if (tipo === "flota") {
        const resumen = resumenPorCamion(cargasComp);
        if (formato === "pdf") {
          this.descargarPdf({ tipo, empresa, fechaInicio, fechaFin, resumen }, `Consumo_Flota_${sufijo}`);
        } else {
          this.descargarExcel(
            resumen.map((r) => ({
              Desde: fechaInicio.format("DD/MM/YYYY"),
              Hasta: fechaFin.format("DD/MM/YYYY"),
              Camión: r.nombre,
              Cargas: r.numCargas,
              Litros: +r.totalLitros.toFixed(2),
              Gasto: +r.gastoTotal.toFixed(2),
              KM: +r.totalKm.toFixed(1),
              "km/L": r.kmPorLitro > 0 ? +r.kmPorLitro.toFixed(2) : "",
              "Costo/km": r.totalKm > 0 ? +r.costoPorKm.toFixed(2) : "",
            })),
            "Consumo por camión",
            `Consumo_Flota_${sufijo}`
          );
        }
      } else if (tipo === "camion") {
        const porChofer = resumenPorChofer(cargasComp);
        const stats = resumenGlobal(cargasComp);
        const registros = [...cargasComp].sort(
          (a, b) => (a.kmOdometro || 0) - (b.kmOdometro || 0)
        );
        const camionNombre = cargasComp[0]?.proyectoNombre || "";
        if (formato === "pdf") {
          this.descargarPdf(
            { tipo, empresa, fechaInicio, fechaFin, porChofer, registros, camionNombre, stats },
            `Consumo_${camionNombre}_${sufijo}`
          );
        } else {
          this.descargarExcel(
            registros.map((r) => ({
              Fecha: r.fecha ? moment(r.fecha).format("DD/MM/YYYY") : "",
              Odómetro: r.kmOdometro || 0,
              Litros: +(r.litros || 0).toFixed(2),
              Tipo: r.tipoCombustible || "",
              "Precio/L": +(r.precioPorLitro || 0).toFixed(2),
              Total: +(r.total || 0).toFixed(2),
              "KM Recorridos": r.kmRecorridos != null ? +r.kmRecorridos.toFixed(1) : "",
              "km/L": r.rendimiento != null ? +r.rendimiento.toFixed(2) : "",
              Chofer: r.choferNombre || "",
            })),
            "Registros",
            `Consumo_${camionNombre}_${sufijo}`
          );
        }
      } else if (tipo === "anomalias") {
        const umbral = values.umbral || 25;
        const anomalias = detectarAnomalias(cargasComp, umbral);
        if (formato === "pdf") {
          this.descargarPdf({ tipo, empresa, fechaInicio, fechaFin, anomalias, umbral }, `Anomalias_${sufijo}`);
        } else {
          this.descargarExcel(
            anomalias.map((a) => ({
              Camión: a.proyectoNombre,
              Fecha: a.fecha ? moment(a.fecha).format("DD/MM/YYYY") : "",
              Chofer: a.choferNombre || "",
              "km/L": a.rendimiento != null ? +a.rendimiento.toFixed(2) : "",
              "Promedio camión": +a.baseline.toFixed(2),
              "Desviación %": a.desviacionPct,
              Alerta: a.tipo,
            })),
            "Anomalías",
            `Anomalias_${sufijo}`
          );
        }
      }
      this.setState({ loading: false });
    } catch (err) {
      this.setState({ loading: false });
      message.error("No se pudo generar el reporte: " + (err?.message || "error"));
    }
  }

  descargarPdf(datos, nombre) {
    try {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.createPdf(reporteCargasCombustiblePdf(datos)).download(nombre);
    } catch (e) {
      message.error("No se pudo generar el PDF: " + e.message);
    }
  }

  descargarExcel(filas, hoja, nombre) {
    if (!filas.length) return message.info("No hay datos para exportar");
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(filas), hoja);
    XLSX.writeFile(wb, `${nombre}.xlsx`);
  }

  render() {
    const { tipo } = this.state;
    const vehiculos = this.props.todosVehiculos || [];
    return (
      <ModalItem
        title="Reportes generales de cargas"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrar.bind(this)}
        forceRender
        paddingTop
      >
        <div style={{ marginBottom: 12 }}>
          <SegmentedItem
            options={TIPOS}
            value={tipo}
            onChange={(v) => this.setState({ tipo: v })}
          />
        </div>

        <Form
          ref={this.formRef}
          name="reportesCargas"
          layoutForm="vertical"
          initialValues={{
            periodo: [moment().startOf("month"), moment().endOf("day")],
            umbral: 25,
          }}
        >
          <Row gutter={12}>
            <Col xs={24}>
              <FormItem name="periodo" label="Período" required>
                <RangePickerItem style={{ width: "100%" }} />
              </FormItem>
            </Col>

            {tipo === "camion" ? (
              <Col xs={24}>
                <FormItem name="camionId" label="Camión" required>
                  <SelectItem showSearch optionFilterProp="children" placeholder="Selecciona un camión">
                    {vehiculos.map((v) => (
                      <Select.Option key={v._id} value={v._id}>
                        {v.nombre}
                      </Select.Option>
                    ))}
                  </SelectItem>
                </FormItem>
              </Col>
            ) : (
              <Col xs={24}>
                <FormItem
                  name="camiones"
                  label="Camiones"
                  tooltip="Déjalo vacío para incluir TODOS los camiones. Selecciona uno o varios para filtrar."
                >
                  <SelectItem
                    mode="multiple"
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    placeholder="Todos los camiones"
                  >
                    {vehiculos.map((v) => (
                      <Select.Option key={v._id} value={v._id}>
                        {v.nombre}
                      </Select.Option>
                    ))}
                  </SelectItem>
                </FormItem>
              </Col>
            )}

            {tipo === "anomalias" && (
              <Col xs={24}>
                <FormItem
                  name="umbral"
                  label="Umbral de desviación (%)"
                  tooltip="Marca cargas cuyo km/L se desvíe más de este porcentaje del promedio de su camión."
                  style={{ marginBottom: 4 }}
                >
                  <InputNumberItem min={1} max={100} placeholder="25" sinWidth style={{ width: 160 }} />
                </FormItem>
                <div
                  style={{
                    background: "#f6fefe",
                    border: "1px solid #d9f5f8",
                    borderRadius: 6,
                    padding: "8px 12px",
                    fontSize: 12,
                    color: "#555",
                    marginBottom: 8,
                  }}
                >
                  <b>¿Cómo funciona?</b> Para cada camión se calcula su rendimiento promedio.
                  Con un umbral del <b>25%</b>, si un camión promedia <b>4 km/L</b>, se marcan las
                  cargas que rindan <b>menos de 3 km/L</b> (−25% → alerta "Bajo": posible fuga o robo)
                  o <b>más de 5 km/L</b> (+25% → alerta "Alto": posible error al capturar el odómetro o los litros).
                  Entre más bajo el umbral, más sensible (marca más cargas).
                </div>
              </Col>
            )}
          </Row>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 10, marginBottom: 6 }}>
            <ButtonItem verde onClick={() => this.generar("excel")} loading={this.state.loading}>
              Descargar Excel
            </ButtonItem>
            <ButtonItem type="primary" rojo onClick={() => this.generar("pdf")} loading={this.state.loading}>
              Generar PDF
            </ButtonItem>
          </div>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalReportesCargas);
